export default {
  index: [
    {
      path: '/zkpttgytcplan',
      component: resolve => require(['./zkpttgytcplanIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkpttgytcplan/_router.js